import React from "react";
import { FiArrowUp, FiArrowDown, FiX } from "react-icons/fi";
import "./FindBar.css";

export default function FindBar({
  query,
  onQueryChange,
  onNext,
  onPrev,
  matchCount,
  currentIndex,
  onClose,
  placeholder,
  className,
  texts,
  autoFocus = true,
}) {
  const t = (texts && texts.app) || {};
  return (
    <div className={`find-bar ${className || ""}`} role="search">
      <input
        className="find-bar__input"
        type="text"
        value={query}
        placeholder={placeholder || t.findPlaceholder || "検索…"}
        onChange={(e) => onQueryChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            onClose();
          } else if (e.key === "Enter") {
            e.preventDefault();
            if (e.shiftKey) onPrev();
            else onNext();
          }
        }}
        autoFocus={autoFocus}
      />
      {query ? (
        <span className="find-bar__count">
          {matchCount > 0 ? `${currentIndex}/${matchCount}` : "0/0"}
        </span>
      ) : null}
      <button
        type="button"
        className="find-bar__btn"
        onClick={onPrev}
        disabled={matchCount === 0}
        title={t.findPrevTitle || "前へ (Shift+Enter)"}
      >
        <FiArrowUp size={16} />
      </button>
      <button
        type="button"
        className="find-bar__btn"
        onClick={onNext}
        disabled={matchCount === 0}
        title={t.findNextTitle || "次へ (Enter)"}
      >
        <FiArrowDown size={16} />
      </button>
      <button
        type="button"
        className="find-bar__btn find-bar__btn--close"
        onClick={onClose}
        title={t.findCloseTitle || "閉じる (Esc)"}
      >
        <FiX size={16} />
      </button>
    </div>
  );
}
